import { OrderState } from '../enums';

export const OrderStateData: { [key: number]: { label: string; className: string; icon?: string; svg?: string } } = {
    [OrderState.Pending]: {
        className: 'item-state-pending',
        label: 'order_state.pending',
        icon: '/assets/icons/cart.png'
    },
    [OrderState.Accepted]: {
        className: 'item-state-accepted',
        label: 'order_state.confirmed',
        icon: '/assets/icons/cart-checked.png'
    },
    [OrderState.Rejected]: { className: 'item-state-rejected', label: 'order_state.rejected', svg: 'icon::cancel' },
    [OrderState.InProgress]: {
        className: 'item-state-in-progress',
        label: 'order_state.in_progress',
        svg: 'icon::fried'
    },
    [OrderState.Available]: { className: 'item-state-available', label: 'order_state.available', svg: 'icon::dish' },
    [OrderState.Canceled]: { className: 'item-state-canceled', label: 'order_state.canceled', svg: 'icon::cancel' },
    [OrderState.Delivering]: {
        className: 'item-state-delivering',
        label: 'order_state.delivering',
        icon: '/assets/icons/in-transit.png'
    },
    [OrderState.Delivered]: {
        className: 'item-state-delivered',
        label: 'order_state.delivered',
        svg: 'icon::delivered'
    },
    [OrderState.Merged]: { className: 'item-state-merged', label: 'order_state.merged', svg: 'icon::delivered' },
    [OrderState.PendingPayment]: {
        className: 'item-state-pending-payment',
        label: 'order_state.pending_payment',
        svg: 'icon::pending_payment'
    },
    [OrderState.Complete]: { className: 'item-state-complete', label: 'order_state.completed', svg: 'icon::check' },
    [OrderState.DriverAllocated]: {
        className: 'item-state-driver-allocated',
        label: 'order_state.driver_allocated',
        svg: 'icon::delivery-man'
    },
    [OrderState.DriverArrived]: {
        className: 'item-state-driver-arrived',
        label: 'order_state.driver_arrived',
        svg: 'icon::delivery-man'
    },
    [OrderState.PaymentSuccess]: {
        className: 'item-state-payment-success',
        label: 'order_state.payment_success',
        svg: 'icon::payment-success'
    },
    [OrderState.PaymentFailed]: {
        className: 'item-state-payment-failed',
        label: 'order_state.payment_failed',
        svg: 'icon::cancel'
    },
    [OrderState.Served]: { className: 'item-state-served', label: 'order_state.served', svg: 'icon::dish' },

    [OrderState.Custom]: { className: 'item-state-pending', label: '', icon: '/assets/icons/new.png' }
};
